import { render, staticRenderFns } from "./AverageIcon.vue?vue&type=template&id=35952188&scoped=true"
import script from "./AverageIcon.vue?vue&type=script&lang=js"
export * from "./AverageIcon.vue?vue&type=script&lang=js"
import style0 from "./AverageIcon.vue?vue&type=style&index=0&id=35952188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35952188",
  null
  
)

export default component.exports